import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { formatCurrency, formatDate } from '../../bank-movements/utils/formatters';

export async function exportCashRetentionsToExcel(movements = [], filename = 'RetencionesEfectivo.xlsx') {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Retenciones y Efectivo');

  worksheet.columns = [
    { header: 'Fecha emisión', key: 'emission_date', width: 18 },
    { header: 'Fecha vencimiento', key: 'due_date', width: 18 },
    { header: 'Tipo', key: 'movement_type_name', width: 30 },
    { header: 'Concepto', key: 'concept', width: 40 },
    { header: 'Comprobante', key: 'voucher_number', width: 20 },
    { header: 'Beneficiario', key: 'legal_entity_name', width: 32 },
    { header: 'Importe', key: 'amount', width: 18 },
    { header: 'Saldo acumulado', key: 'accumulated_balance', width: 20 },
  ];

  movements.forEach((movement) => {
    worksheet.addRow({
      emission_date: movement.emission_date ? formatDate(movement.emission_date) : '-',
      due_date: movement.due_date ? formatDate(movement.due_date) : '-',
      movement_type_name: movement.movement_type_name || '-',
      concept: movement.concept || '-',
      voucher_number: movement.voucher_number || '-',
      legal_entity_name: movement.legal_entity_name || '-',
      amount: formatCurrency(movement.amount ?? 0, 2),
      accumulated_balance: formatCurrency(movement.accumulated_balance ?? 0, 2),
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
}
